import React, { useEffect, useContext } from "react";
import { icons } from "../../../constants";
import "../styles/styles.css";
import "../../../styles/global.css";
import { useTheme } from "../../../utils/ThemeContext";
import { TranslationsContext } from "../../../utils/TranslationsContext";

// Only two possible values, so this is a plain toggle button, not a
// dropdown/reveal picker like Languages (which can have more than two
// options) — one click/tap always flips light<->dark immediately.
const Themes = ({ setIsBarOpen, changeThemeInNavbar }) => {
  const { theme, setTheme } = useTheme();
  const { t } = useContext(TranslationsContext);

  useEffect(() => {
    document.body.classList.toggle("dark-theme", theme === "dark");
    localStorage.setItem("theme", theme);
    changeThemeInNavbar?.(theme);
  }, [theme, changeThemeInNavbar]);

  const handleToggle = () => {
    setTheme(theme === "light" ? "dark" : "light");
    setIsBarOpen?.(false);
  };

  // Same icon variants as before: the light/dark-mode-appropriate render of
  // whichever icon matches the current theme, for contrast against the
  // current navbar background.
  const icon = theme === "light" ? icons.light : icons.dark_dark;

  return (
    <div
      className="flex-direction-row items-center navbar-themes-wrapper"
      style={{ height: "58px" }}
    >
      <div
        className="flex-direction-row items-center justify-center pointer selected-language"
        onClick={handleToggle}
        style={{ height: "44px" }}
      >
        <img
          src={icon}
          alt={`${theme}_icon`}
          className="selected-theme-img"
          width={28}
          height={28}
        />
        {/* Only shown in the expanded sidebar (see .navbar-setting-label). */}
        <span className="navbar-setting-label">
          {theme === "light" ? t("THEME_LIGHT") : t("THEME_DARK")}
        </span>
      </div>
    </div>
  );
};

export default Themes;
